import { render, staticRenderFns } from "./PageSearch.vue?vue&type=template&id=7fb788b0&scoped=true"
import script from "./PageSearch.vue?vue&type=script&lang=js"
export * from "./PageSearch.vue?vue&type=script&lang=js"
import style0 from "./PageSearch.vue?vue&type=style&index=0&id=7fb788b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb788b0",
  null
  
)

export default component.exports